import dayjs from 'dayjs';
import utcPlugin from 'dayjs/plugin/utc';
dayjs.extend(utcPlugin);
import { ABSOLUTE_TIME_FORMAT } from '../contants';
export var getDefaultAbsoluteTime = function () {
    try {
        var start = dayjs
            .utc()
            .subtract(1, 'day')
            .startOf('day')
            .format(ABSOLUTE_TIME_FORMAT);
        var end = dayjs().startOf('day').format(ABSOLUTE_TIME_FORMAT);
        return {
            start: start,
            end: end,
        };
    }
    catch (err) {
        return null;
    }
};
export default getDefaultAbsoluteTime;
